import React, { ReactNode } from 'react';

import RootModalLayout from '../RootModalLayout';

import classes from '../SharedModal.module.scss';

interface SettingsModalProps {
  title: string;
  children: ReactNode;
  onClose: () => void;
}

export const SettingsModal: React.FC<SettingsModalProps> = ({ title, children, onClose }) => (
  <RootModalLayout title={title} onClose={onClose}>
    <section className={classes.mainContent}>{children}</section>
  </RootModalLayout>
);
